document.addEventListener('DOMContentLoaded',()=>{
    if( document.querySelectorAll('.ci__support__conf_closed').length > 0 ){
      document.querySelectorAll('.ci__support__conf_closed').forEach((el)=>{
        el.addEventListener('click', (target)=>{
          target.preventDefault();
          target.target.closest('.ci__support__shop_confirmation').classList.remove('active');
          document.querySelector('.page-overlay').classList.remove('is-visible');
          document.body.classList.remove('overflow-hidden');
        })
      })
    }

    function closePopup() {
      document.querySelector('.chronic-illness-slide-out')?.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }

    if( document.querySelectorAll('.show-more a').length > 0 ){  
      document.querySelectorAll(".show-more a").forEach(link => {
        link.addEventListener("click", function (e) {
          e.target.closest('.form__checkbox--button').querySelector('.chronic-illness-slide-out__checkboxs').querySelectorAll('.field.collapsible_field').forEach((el)=>{
            el.classList.toggle('active');
          })
        link.textContent = ( link.textContent == 'Show more') ? 'Show less' : 'Show more';
        });
      });
    }

    document.querySelectorAll('.chronic-illness-slide-out__overlay, .chronic-illness-slide-out__close').forEach(elm => {
      elm.addEventListener('click', closePopup);
    }); 
    
    let globalCheckedValues = [];
    const checkboxes = document.querySelectorAll(".chronic-illness-slide-out__checkboxs input[type=checkbox]");
    const customField = document.querySelector(".custom__msg--field");
    const customInput = document.getElementById("ContactFormCustomMessage");
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener("change", function () {
        const isOther = this.value === "Other";
        if (isOther) {
          if (this.checked) {
            customField.style.display = "flex";
          } else {
            customField.style.display = "none";
            if (customInput) customInput.value = '';
          }
        }
        updateCheckedValues();
      });
    });
    
    if (customInput) {
      customInput.addEventListener("input", updateCheckedValues);
    }
    
    function updateCheckedValues() {
      globalCheckedValues = Array.from(
        document.querySelectorAll(".chronic-illness-slide-out__checkboxs input[type=checkbox]:checked")
      ).map(input => input.value);
    
      if (globalCheckedValues.includes("Other")) {
        const message = customInput?.value?.trim();
        if (message) {
          globalCheckedValues.push(message);
        }
      }
    }
    
    ['#ContactForm-phone', '#ContactForm-email'].forEach(selector => {
      const input = document.querySelector(selector);
      if (input) {
        input.addEventListener('keyup', (e) => {
          e.target.classList.remove('notvalid__number');
        });
      }
    });
    
    document.querySelector('#ContactForm-phone').addEventListener('change', (elm)=>{
      let Phone$Value = elm.target.value;
      let country$CodeRegex = /^\+(\d{1,3})/; 
      if ( Phone$Value.length === 0  ){
        elm.target.classList.remove('notvalid__number');
      }else if (country$CodeRegex.test(Phone$Value)) {
        elm.target.classList.add('notvalid__number');
      }else if( (Phone$Value.length >10) || (Phone$Value.length < 10) && !isNaN(Phone$Value) ){
        elm.target.classList.add('notvalid__number');
      }else if( isNaN(Phone$Value) ){ 
        elm.target.classList.add('notvalid__number');
      }else{
        elm.target.classList.remove('notvalid__number');
      }
    })
      
    document.querySelector('#ContactForm-email').addEventListener('change', (elm)=>{
      let Email$Value = elm.target.value.toLowerCase();
      let email$CodeRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if ( Email$Value.length === 0  ){
        elm.target.classList.remove('notvalid__number');
      }else if ( !Email$Value.includes('.com') &&
                !Email$Value.includes('.org') &&
                !Email$Value.includes('.edu') &&
                !Email$Value.includes('.gov') &&
                !Email$Value.includes('.net') &&
                !Email$Value.includes('.int') &&
                !Email$Value.includes('.mil') &&
                !Email$Value.includes('.arpa') &&
                !Email$Value.includes('.amex') &&
                !Email$Value.includes('.art') &&
                !Email$Value.includes('.co')
              ) {
        elm.target.classList.add('notvalid__number');
      }else if (!email$CodeRegex.test(Email$Value)) {
        elm.target.classList.add('notvalid__number');
      }else{
        elm.target.classList.remove('notvalid__number');
      }  
    }) 
    
    document.getElementById('chronicIllnessForm')?.addEventListener('submit', async function (event) {
      event.preventDefault();
      const firstName = document.getElementById('ContactFormFirstName')?.value?.trim() || '';
      const lastName = document.getElementById('ContactFormLastName')?.value?.trim() || '';
      const email = document.getElementById('ContactForm-email')?.value?.toLowerCase().trim() || '';
      const phone = document.getElementById('ContactForm-phone')?.value?.trim() || '';
      const mobile = phone ? `+1${phone}` : '';
      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  properties: {
                    'Chronic Illness': globalCheckedValues || [],
                    'SMS Consent': 'FALSE'
                  },
                  email,
                  phone_number: mobile, 
                  first_name: firstName,
                  last_name: lastName
                },
                meta: {
                  patch_properties: {
                    append: {
                      newKey: 'New Value'
                    },
                    unappend: {
                      newKey: 'New Value'
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: 'TE6KNC'
              }
            }
          }
        }
      };
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UFRh4Z', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'REVISION': '2024-07-15'
          },
          body: JSON.stringify(payload)
        });
        if (!response.ok) {
          throw new Error(`Request failed. Status: ${response.status}`);
        }
        const responseText = await response.text();
        document.querySelector('.chronic-illness-slide-out ')?.classList.remove('active');
        document.querySelector('.ci__support__shop_confirmation')?.classList.add('active');
        document.querySelector('.page-overlay').classList.add('is-visible');
        document.body.classList.add('overflow-hidden');
        if (responseText) { 
          try {
            const json = JSON.parse(responseText);
          } catch (err) {
            console.error('Invalid JSON response:', err);
          }
        } else {
          console.log('Response was empty');
        }
        globalCheckedValues = [];
    
      } catch (error) {
        console.error('Submission error:', error);
      }
    }); 
}) 